var serverOriginMapWithBoe = {
    clue: {
        prod: 'clue.oceanengine.com',
        boe: 'clue-boe.oceanengine.com',
    },
    chengzi: {
        prod: 'www.chengzijianzhan.com',
        boe: 'www-boe.chengzijianzhan.com',
    },
};
var cdnOriginMap = {
    'tos-lf1-hs': 'lf1-cdn-tos.huoshanstatic.com',
    'tos-lf3-hs': 'lf3-cdn-tos.huoshanstatic.com',
    'tos-lf6-hs': 'lf6-cdn-tos.huoshanstatic.com',
    'tos-sf3-tt': 'sf3-cdn-tos.douyinstatic.com',
    'tos-sf1-tt': 'sf3-cdn-tos.douyinstatic.com',
    'tos-sf6-tt': 'sf3-cdn-tos.douyinstatic.com',
    'tos-sf6-hs': 'sf6-cdn-tos.huoshanstatic.com',
    'verify.snssdk': 'verify.snssdk.com',
};
export var serverOrigins = Object.keys(serverOriginMapWithBoe).reduce(function (a, b) {
    a[b] = b;
    return a;
}, {});
export function getServerPath(originName, path, isHttps) {
    if (path === void 0) { path = ''; }
    if (isHttps === void 0) { isHttps = true; }
    return (isHttps ? 'https' : 'http') + "://" + serverOriginMapWithBoe[originName]['prod'] + path;
}
export var cdnOrigins = Object.keys(cdnOriginMap).reduce(function (a, b) {
    a[b] = b;
    return a;
}, {});
export function getStaticPath(originName, path) {
    if (path === void 0) { path = ''; }
    return "https://" + cdnOriginMap[originName] + path;
}
